import React, { Component } from 'react';
import { Button, Form, Header, Icon, Modal } from 'semantic-ui-react';

import API from '../services/api.js';
import _ from 'lodash';

const optionsOrderType = [
	{
		key: 'Market',
		text: 'По маркету',
		value: 'Market'
	},
	{
		key: 'Limit',
		text: 'Лимитный',
		value: 'Limit'
	},
];

const optionsLeverageMode = [
	{
		key: 0,
		text: 'Кросс',
		value: 0
	},
	{
		key: 1,
		text: 'Изолированая',
		value: 1
	},
];

class Order extends Component {

	constructor (props) {
		super(props);

		this.state = {
			symbol: props.symbol,
			percent: 0,
			value: 0,
			size: 0,
			price: props.position.avgPrice,
			orderType: 'Limit',
			position: props.position
		};

		this.closeModal = props.closeModal;
	}

	makeOrder = async (side) => {
		const {
			symbol,
			percent,
			value,
			size,
			price,
			orderType = 'Limit'
		} = this.state;

		try {
			await API.Order[side](symbol, {
				percent,
				value,
				size,
				price,
				orderType,
				skip: true
			});
			this.closeModal();
		} catch (err) {
			console.error(err);
		}
	}

	handleChangeNumber = (key) => async (e, { value }) => {
		await this.setState({ [key]: Number(_.trimStart(value, '0')) || 0 });
	};

	handleChange = (key) => (e, { value }) => {
		this.setState({ [key]: value });
	};

	handleFocus = (event) => event.target.select();

	render () {
		const {
			symbol,
			percent,
			value,
			price,
			orderType
		} = this.state;

		return (<>
				<Header icon="archive" content={`Новый ордер для усреднения: ${symbol}`}/>
				<Modal.Content>
					<Form>
						<Form.Group widths="equal">
							<Form.Input fluid label={'% от депозита:'} type={'number'} placeholder="10" value={percent} onFocus={this.handleFocus} onChange={(e, d) => { this.handleChangeNumber('percent')(e,d); this.setState({value: 0})}} />
							<Form.Input fluid label={'USDT:'} type={'number'} placeholder="" value={value} onFocus={this.handleFocus} onChange={(e, d) => { this.handleChangeNumber('value')(e,d); this.setState({percent: 0})}}/>
						</Form.Group>
						<Form.Group widths="equal">
							<Form.Select
								fluid
								label={'Тип ордера'}
								options={optionsOrderType}
								value={orderType}
								onChange={this.handleChange('orderType')}
							/>
							<Form.Input fluid label={'Цена в случае лимитного ордера:'} placeholder="10" value={price} onFocus={this.handleFocus} onChange={this.handleChange('price')}/>
						</Form.Group>
					</Form>
				</Modal.Content>
				<Modal.Actions>
					<Button onClick={this.closeModal}>
						<Icon name="remove"/> Закрыть
					</Button>
					<Button color="green" onClick={() => this.makeOrder('buy')}>
						<Icon name="arrow up"/> BUY
					</Button>
					<Button color="red" onClick={() => this.makeOrder('sell')}>
						<Icon name="arrow down"/> SELL
					</Button>
				</Modal.Actions>
			</>
		);
	}
}

export default Order;
